import React, { useContext, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-hot-toast";
import "./Navbar.css";

const Navbar = () => {
  const { user, logout, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      logout();
      toast.success("Logged out successfully");
      navigate("/login");
    }
  };

  if (location.pathname === "/login" || location.pathname === "/") {
    return null;
  }

  const isActive = (path) =>
    location.pathname === path ? "nav-link active" : "nav-link";

  return (
    <nav className={`sidebar ${isMobileMenuOpen ? "mobile-open" : ""}`}>
      <div className="sidebar-header">
        <Link
          to="/dashboard"
          className="sidebar-brand"
          onClick={closeMobileMenu}
        >
          <span className="logo-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </span>{" "}
          TMS
        </Link>
        <button className="mobile-toggle" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      <div className="sidebar-nav">
        {isAuthenticated ? (
          <div className="nav-links">
            <div className="nav-group-label">Navigation</div>
            <Link
              to="/dashboard"
              className={isActive("/dashboard")}
              onClick={closeMobileMenu}
            >
              <span className="nav-icon">🏠</span> Home
            </Link>
            <div className="nav-group-label">My Dashboard</div>
            {(user?.role === "User" || user?.role === "SuperAdmin") && (
              <Link
                to="/complaints/new"
                className={isActive("/complaints/new")}
                onClick={closeMobileMenu}
              >
                <span className="nav-icon">✏️</span> Raise Complaint
              </Link>
            )}
            {user?.role !== "SuperAdmin" && (
              <Link
                to="/my-complaints"
                className={isActive("/my-complaints")}
                onClick={closeMobileMenu}
              >
                <span className="nav-icon">📋</span> My Complaints
              </Link>
            )}

            {user?.role === "SuperAdmin" && (
              <>
                <div className="nav-group-label">Admin Panel</div>
                <Link
                  to="/departments"
                  className={isActive("/departments")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">🏢</span> Departments
                </Link>
                <Link
                  to="/programmes"
                  className={isActive("/programmes")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">📚</span> Programmes
                </Link>
                <Link
                  to="/blocks"
                  className={isActive("/blocks")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">🏗️</span> Blocks
                </Link>
                <Link
                  to="/rooms"
                  className={isActive("/rooms")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">🚪</span> Rooms
                </Link>
                <Link
                  to="/roles"
                  className={isActive("/roles")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">🛡️</span> Roles
                </Link>
                <Link
                  to="/users"
                  className={isActive("/users")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">👥</span> Users
                </Link>
                <Link
                  to="/complaints"
                  className={isActive("/complaints")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">🗂️</span> All Complaints
                </Link>
                <Link
                  to="/reports"
                  className={isActive("/reports")}
                  onClick={closeMobileMenu}
                >
                  <span className="nav-icon">📊</span> Reports
                </Link>
              </>
            )}
          </div>
        ) : (
          <div className="nav-links">
            <Link to="/login" className={isActive("/login")}>
              <span className="nav-icon">🔐</span> Login
            </Link>
          </div>
        )}
      </div>

      <div className="sidebar-footer">
        {isAuthenticated && (
          <div className="user-actions">
            <div className="user-card">
              <div className="user-avatar">
                {user?.username?.charAt(0).toUpperCase() || "U"}
              </div>
              <div className="user-info">
                <span className="user-greeting">Signed in as</span>
                <span className="user-name">{user?.username}</span>
              </div>
            </div>
            <button onClick={handleLogout} className="logout-btn">
              <span>Log Out</span>
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
